import { Tabs, TabsProps } from "antd";
import CompanyInvitationsV2 from "../invitation/CompanyInvitationsV2";
import CustomLabel from "../share/customLabel";
import { ColorPalette } from "../share/color/colorPalette";
import { useNavigate } from "react-router-dom";
import PersonelInvitationView from "../invitation/PersonelInvitationView";
import AcceleratorManagement from "../Notice/Accelerator/AcceleratorManagement";
import Positions2 from "../position/Positions2";
import AddAddress from "./AddAddress";
import CompaniesView from "./CompaniesView";

const CompanyInfo = () => {
  const navigate = useNavigate();
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: " اطلاعات اصلی   ",
      children: <CompaniesView />,
    },
    // {
    //   key: "2",
    //   label: "همکاران من",
    //   children: "",
    // },
    {
      key: "4",
      label: "دعوتنامه پرسنلی",
      children: <PersonelInvitationView />,
    },
    {
      key: "5",
      label: "چارت سازمانی",
      children: <Positions2 />,
    },
    // {
    //   key: "6",
    //   label: "مدارک فروشگاهی",
    //   children: "",
    // },
    {
      key: "7",
      label: "آدرس های من",
      children: <AddAddress />,
    },
  ];
  const onChange = (key: string) => {
    navigate(`/CompanyInfo?tab=${key}`);
  };

  return (
    <>
      {/* <h3
        style={{
          fontFamily: "YekanBakhVF",
          fontWeight: "600",
          fontSize: "32px",
          lineHeight: "44.8px",

          color: ColorPalette.gray[950],
          marginRight: "1rem",
        }}
        className="mt-2"
      >
        پروفایل فروشگاه
      </h3> 
      <br />
      */}

      <Tabs
        style={{ fontFamily: "YekanBakhVF" }}
        tabBarStyle={{ marginBottom: 1 }} // Reduces spacing below tab headers
        defaultActiveKey="1"
        items={items}
        onChange={onChange}
      />
    </>
  );
};
export default CompanyInfo;
